// extracted by mini-css-extract-plugin
module.exports = {"bgBlue":"styles_bgBlue__19QBo","bgGreen":"styles_bgGreen__3QKnZ","bgYellow":"styles_bgYellow__2LiQ7"};